export default "__VITE_ASSET__CN4K0sqn__"